import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { Link, useLocation, matchPath } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import profiles from '../../utils/profileUtils';
import './NavBar.css';
import { NavIcons } from './NavIcons';
import { NavButton } from './NavButton';
import Avatar from '@mui/material/Avatar';
import ModalProfile from './Modal_profile';

const dropdownRoutes = [
  '/unidades',
  '/canais',
  '/personalidades',
  '/palavras_chave',
];

const usersGroups = ['EDITOR', 'ADMIN', 'MANAGER'];

export const NavBar = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await Auth.signOut();
      setIsAuthenticade(false);
      navigate('/login');
    } catch (err) {
      console.log(err);
    }
  };

  const [isAuthenticated, setIsAuthenticade] = useState(false);
  const [open, setOpen] = useState(false);
  const [menuExpanded, setMenuExpanded] = useState(false);

  const [userName, setUserName] = useState();

  const [userProfile, setUserProfile] = useState();

  const [auth] = useOutletContext();

  const { pathname } = useLocation();

  const matchDropDownRouter = useMemo(
    () => dropdownRoutes.some(route => matchPath(route, pathname)),
    [pathname]
  );

  useEffect(() => {
    async function getAuthenticated() {
      try {
        setIsAuthenticade(true);
        setUserName(auth.getIdToken().payload.name);
        setUserProfile(auth.getIdToken().payload['custom:user_profile']);
      } catch (error) {
        return '';
      }
    }
    getAuthenticated();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleMenuItemClick = event => {
    const selectedLink = event.target.closest(
      'a.nav-link:not(.dropdown-toggle), a.dropdown-item'
    );

    if (selectedLink) {
      setMenuExpanded(false);
    }
  };

  if (isAuthenticated === true) {
    return (
      <div>
        <Navbar
          collapseOnSelect
          expand={false}
          expanded={menuExpanded}
          onToggle={setMenuExpanded}
          onSelect={() => setMenuExpanded(false)}
          className="navbar_menu">
          <Container className="nav-bar-container">
            <div className="navbar_logo_image">
              <div>
                <img
                  alt=""
                  src="/img/Logo_SescDigital_Pos.svg"
                  className="image_navbar_logo_image"
                />
              </div>
            </div>

            <div className="navbar_actions">
              <Navbar.Toggle
                aria-controls="responsive-navbar-nav"
                className="navbar_toggle"
              />
              <div className="navbar_user_menu">
                <NavDropdown
                  className="navbar_user_name"
                  title={userName}
                  id="collasible-nav-dropdown">
                  <NavDropdown.Item
                    as={Link}
                    to="#action/3.2"
                    //onClick={(e) => handleButtonClick(e,user)}
                    onClick={() => handleClickOpen()}
                    className="dropdown_user_profile">
                    <NavIcons.Profile /> Perfil
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="#action/3.2"
                    onClick={handleLogout}
                    className="dropdown_user_profile">
                    <NavIcons.Exit /> Sair
                  </NavDropdown.Item>
                </NavDropdown>
                <div className="navbar_user_profile">
                  {profiles[userProfile]}
                </div>
              </div>
              <div className="navbar_icon_name">
                <Avatar
                  sx={{ backgroundColor: '#c5c5c5', width: 35, height: 35 }}>
                  {userName.substring(0, 1).toUpperCase()}
                </Avatar>
              </div>
            </div>
            <Navbar.Collapse
              id="responsive-navbar-nav"
              onClick={handleMenuItemClick}>
              <Nav className="me-auto">
                {usersGroups.includes(userProfile) && (
                  <div className="navbar_items">
                    <NavButton to="/">
                      <NavIcons.Home /> Início
                    </NavButton>
                  </div>
                )}

                {usersGroups.includes(userProfile) && (
                  <div className="navbar_items">
                    <NavButton to="/videos">
                      <NavIcons.Video /> Vídeos
                    </NavButton>
                  </div>
                )}

                {usersGroups.includes(userProfile) && (
                  <div className="navbar_items">
                    <NavButton to="/series">
                      <NavIcons.Presentation /> Séries
                    </NavButton>
                  </div>
                )}

                {usersGroups.includes(userProfile) && (
                  <div className="navbar_items">
                    <NavButton to="/colecoes-novo">
                      <NavIcons.Collection /> Coleções (Novo)
                    </NavButton>
                  </div>
                )}

                {['ADMIN'].includes(userProfile) && (
                  <div className="navbar_items">
                    <NavButton to="/relatorios">
                      <NavIcons.Reports /> Relatórios
                    </NavButton>
                  </div>
                )}

                {['ADMIN', 'MANAGER'].includes(userProfile) && (
                  <div className="navbar_items">
                    <NavButton to="/usuarios">
                      <NavIcons.Users /> Gestão de Usuários
                    </NavButton>
                  </div>
                )}

                {userProfile === 'ADMIN' && (
                  <div className="navbar_items">
                    <NavButton to="/aplicativo">
                      <NavIcons.Application /> Home do App
                    </NavButton>
                  </div>
                )}

                {userProfile === 'ADMIN' && (
                  <div className="navbar_items">
                    <NavDropdown
                      className={matchDropDownRouter ? 'navActive' : ''}
                      title={
                        <div
                          className={
                            matchDropDownRouter ? 'dropdown_menu_active' : ''
                          }
                          style={{ display: 'inline-block' }}>
                          <NavIcons.Registrations /> Cadastros{' '}
                        </div>
                      }
                      id="collasible-nav-dropdown">
                      {[
                        {
                          label: 'Unidades',
                          to: '/unidades',
                          icon: <NavIcons.Units />,
                        },
                        {
                          to: '/canais',
                          label: 'Canais',
                          icon: <NavIcons.Channels />,
                        },
                        {
                          label: 'Personalidades',
                          to: '/personalidades',
                          icon: <NavIcons.Personalities />,
                        },
                        {
                          label: 'Palavras-Chave',
                          to: '/palavras_chave',
                          icon: <NavIcons.KeyWords />,
                        },
                      ].map(i => (
                        <NavDropdown.Item key={i.to} as={Link} to={i.to}>
                          {i.icon} {i.label}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>
                  </div>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <ModalProfile
          open={open}
          onClose={() => setOpen(false)}
          userName={userName}
          avatar={userName.substring(0, 1).toUpperCase()}
          email={auth.getIdToken().payload.email}
          userRole={profiles[userProfile]}
          description={
            userProfile === 'ADMIN'
              ? 'Perfil Administrador(a): permissão para criar, editar e gerenciar toda plataforma (Sem restrição de acesso).'
              : userProfile === 'MANAGER'
                ? 'Perfil Gestor(a): permissão para criar, editar e gerenciar conteúdos relacionados a unidade/canal ao qual está vinculado (Acesso Vídeos/Séries/Coleções/Usuários).'
                : userProfile === 'EDITOR'
                  ? 'Perfil Editor(a): permissão para criar, editar conteúdos relacionados a unidade/canal ao qual está vinculado (Acesso Vìdeos/Séries/Coleções).'
                  : ''
          }
        />
      </div>
    );
  }
};
